<template lang="pug">
  .grouping-job-table.company
    .table-line.company-row
      .col.accordion
        span(v-if="job.inner_hits.length" @click="toggleAccordion()" :class="{'open': isOpened}")
      .col.check
        label.checkbox
          input(
            type="checkbox",
            :value="job.id",
            :checked='checked',
            :disabled="isGlobalLocked",
            @click="check($event, job.id)"
          )

      GroupingJobTableFavoriteStar(:job="job", @update="update", :updateFavorForIndex="updateFavorForIndex")
      GroupingJobTableMark(:job="job", @update="update", :updateMarkForIndex="updateMarkForIndex")
      .col.company-name
        span
          | {{ job.company_name }}
      .col.company-tel
        span
          | {{ job.display_company_tel }}
      .col.jobtype-name
        a(@click="display")
          | {{ job.jobtype_name }}
      .col.only-sp.job-row-sp
        span.only-sp
          | メディア
        span
          | {{ job.media_name }}
      .col.only-sp.job-row-sp
        span.only-sp
          | 広告プラン
        span
          | {{ job.article_plan_name }}
      .col.only-pc.salary
        span
          | {{ job.salary }}
      .col.job-row-sp
        span.only-sp
          | 掲載開始日
        span
          | {{ job.acquisition_date }}
      .col.only-pc
        span(v-for="c in job.view_end_date")
          | {{ c }}
          br
      .col.posting-situation
        span.view(v-if="job.posting")
          | 掲載中
        span.view-end(v-else)
          | 終了
      .col.only-pc
        span
          | {{ job.media_name }}
      .col.only-pc
        span(v-if="job.article_plan") {{ job.article_plan.toLocaleString("ja-JP") }}万円
        span(v-if="job.article_plan === 0") 0円
        span(v-else) &nbsp;
      .col.new.job-row-sp
        span.label(v-if="job.is_new") NEW

</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import GroupingJobTableFavoriteStar from './JobTableFavoriteStar'
  import GroupingJobTableMark from './JobTableMark'

  export default {
    components: { GroupingJobTableFavoriteStar, GroupingJobTableMark },
    data () {
      return {
        isOpened: false,
      }
    },
    props: ['job', 'checkedIds', 'updateFavorForIndex', 'updateMarkForIndex'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      checked () {
        return this.checkedIds.has(this.job.id)
      },
    },
    methods: {
      ...mapMutations('job', ['clearDetail']),
      toggleAccordion () {
        this.$emit('toggleAccordion')
        this.isOpened = !this.isOpened
      },
      check (event, id) {
        event.preventDefault()
        const checked = event.currentTarget.checked
        this.$emit('check', { checked, id })
      },
      display (e) {
        e.stopPropagation()
        this.$emit('display', { id: this.job.id })
      },
      update () {
        this.clearDetail()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/grouping-job/CompanyTableRow.vue